export const InterviewsStatus = {
  CANCELLED: 'Cancelled',
  CONFIRMED: 'Confirmed',
  LIVE: 'Live',
  PAST: 'Past',
  REQUESTED: 'Requested',
  SCHEDULED: 'Scheduled',
  TODAY: 'Today',
  UNKNOWN: 'Unknown',
} as const;

export const InterviewAttendeeResponses = {
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  PENDING: 'Pending',
  TENTATIVE: 'Tentative',
} as const;

export const InterviewSort = {
  INTERVIEW_DATE: 'InterviewDate',
  INTERVIEW_STATUS: 'InterviewStatus',
  JOB_NAME: 'JobName',
  TALENT_NAME: 'TalentName',
} as const;

export const InterviewOwner = {
  accountManagerOwnerOrSalesLead: 'Owned by me',
  collaborator: 'Collaborating on',
} as const;

export const InterviewBadgeColors = {
  Cancelled: 'gray',
  Confirmed: 'navy blue',
  Live: 'forest green',
  Past: 'gray',
  Requested: 'red',
  Scheduled: 'green',
  Today: 'green',
  Unknown: 'red',
} as const;
